<template>
    <div class="order-container">
        <div class="write-off-title">
            当前客户存在多个待提货订单，请选择订单核销提货
        </div>
        <div class="order-list" v-if="orderlist.length > 0">
            <van-checkbox-group v-model="orderresult" ref="orderlistgroup">
                <van-checkbox checked-color="#DCBB89" v-for="(item, index) in orderlist" :key="index" :name="item.order_uuid">
                    <div class="order-info">
                        <div class="order-top">
                            <div class="order-name">{{ item.user_name }}</div>
                            <div class="order-status">待提货</div>
                        </div>
                        <div class="order-bottom">
                            <div class="order-title">
                                手 机 号：
                                <span class="title-content">{{ item.user_phone }}</span>
                            </div>
                            <div class="order-title">
                                下单时间：
                                <span class="title-content">{{ item.create_time }}</span>
                            </div>
                            <div class="order-list-title">
                                <div class="title-content-list">
                                    商品列表：
                                </div>
                                <div class="content-list">
                                    <div v-for="(shopitem, shopindex) in item.products" :key="shopindex">
                                        {{ shopitem.product_name }} * {{ shopitem.num }}
                                    </div>
                                </div>

                            </div>
                            <div class="order-title">
                                订单金额：
                                <span class="title-content">{{ item.pay_amount }}元</span>
                            </div>
                        </div>
                    </div>
                </van-checkbox>
            </van-checkbox-group>
        </div>
        <div class="no-order-container" v-else>
            <img :src="comapi.getImageUrl('wxmini/img/orderlist_none.png')" class="no-order-img">
            <div class="no-order">暂无订单</div>
        </div>
        <!-- 底部加载触发区 -->
        <div class="loading-trigger" ref="loadTrigger">
            <div v-if="isLoading && orderlist.length > 0" class="loading-state">
                <span class="spinner"></span> 正在加载中...
            </div>
            <div v-else-if="isFinished" class="finished-state">
                - 没有更多订单了 -
            </div>
            <div v-else class="idle-state">
                <!-- 这里的空div是为了占位，让Observer能监测到 -->
            </div>
        </div>
    </div>
    <div class="border-bottom">
        <div class="border-center">
            <van-checkbox class="full-select" v-model="isSelected" checked-color="#DCBB89"
                @change="selectOrder">全选</van-checkbox>
        </div>
        <div class="border-cancel" @click="blankCancel">取消</div>
        <div class="border-go" @click="goWriteOff">前往核销</div>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import comapi from "@/utils/api/com";
import { useRouter, useRoute } from 'vue-router'
import { showToast } from 'vant'
import storeApi from '@/utils/api/store'

const router = useRouter()
const route = useRoute()
const shop_uuid = JSON.parse(localStorage.getItem('departmentdata')).department_uuid;
const user_uuid = route.query.user_uuid;
const page = ref(0);
const orderlist = ref([])
const isLoading = ref(false); // 是否正在加载
const isFinished = ref(false); // 是否已加载完所有数据
const loadTrigger = ref(null); // 滚动触发元素
let observer = null; // 交叉观察器

const isSelected = ref(false)
const orderresult = ref([]);
const orderlistgroup = ref(null);
// 全选/取消全选
const selectOrder = () => {
    if (isSelected.value) {
        orderlistgroup.value.toggleAll(true);
    } else {
        orderlistgroup.value.toggleAll(false);
    }
    orderresult.value = isSelected.value ? orderlist.value.map(item => item.order_uuid) : [];
}
//取消返回上一页
const blankCancel = () => {
    router.back()
}
// 前往核销
const goWriteOff = () => {
    if (orderresult.value.length === 0) {
        showToast('请选择订单')
        return
    }
    localStorage.setItem('orderresult', JSON.stringify(orderresult.value));
    router.push({
        path: '/orderwrite',
        query: {
            user_uuid: user_uuid
        }
    })
}

// 加载更多
const loadMore = async () => {
    if (isLoading.value || isFinished.value) return;
    isLoading.value = true;

    try {
        const nextPage = page.value + 1;
        const newItems = await getWriteOffOrderList(nextPage);

        if (newItems.length > 0) {
            page.value = nextPage;
            if (newItems.length < 10) {
                isFinished.value = true;
            }
        } else {
            isFinished.value = true;
        }
    } catch (error) {
        console.error('加载更多失败', error);
    } finally {
        isLoading.value = false;
    }
};
//获取核销订单列表
const getWriteOffOrderList = async (pageNum = 1) => {
    try {
        const res = await storeApi.getWriteOffOrderList({
            user_uuid: user_uuid,
            shop_uuid: shop_uuid,
            page: pageNum,
            page_size: 10
        })
        if (res.code === 200) {
            if (pageNum === 1) {
                // 第一页，替换数据
                orderlist.value = res.data || [];
            } else {
                // 后续页，追加数据
                orderlist.value = [...orderlist.value, ...(res.data || [])];
            }
            return res.data || [];
        }
        return [];
    } catch (error) {
        console.error('获取核销订单列表失败', error);
        return [];
    }
}
onMounted(() => {
    // 设置交叉观察器
    observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            loadMore();
        }
    }, {
        threshold: 0.1,
        rootMargin: '50px'
    });

    // 观察触发元素
    if (loadTrigger.value) {
        observer.observe(loadTrigger.value);
    }
});

onUnmounted(() => {
    // 销毁监听器
    if (observer) observer.disconnect();
});
</script>
<style lang="less" scoped>
.order-container {
    height: calc(100vh - 70px);
    margin-bottom: 70px;
    overflow: auto;

    .write-off-title {
        font-size: 14px;
        font-weight: 500;
        color: #3C211F;
        font-style: normal;
        text-transform: none;
        margin-bottom: 5px;
        font-family: 'PingFang SC-Medium';
        padding: 17px 13px;
        text-align: center;
        background-color: rgba(220, 187, 137, 0.08);
    }

    .no-order-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 100px;

        .no-order-img {
            width: 142px;
            height: 121px;
            margin-bottom: 10px;
        }

        .no-order {
            font-size: 15px;
            color: #666;
        }
    }

    // 加载触发区样式
    .loading-trigger {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
        text-align: center;

        .loading-state {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
            font-size: 14px;
            gap: 8px;
        }

        .finished-state {
            color: #999;
            font-size: 14px;
        }

        .idle-state {
            height: 20px;
        }

        // 加载动画
        .spinner {
            display: inline-block;
            width: 16px;
            height: 16px;
            border: 2px solid #f3f3f3;
            border-top: 2px solid #DCBB89;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }

            100% {
                transform: rotate(360deg);
            }
        }
    }

    .order-list {
        padding: 13px 17px;

        .order-info {
            background-color: #fff;
            padding: 15px 13px 6px 13px;
            margin-bottom: 10px;
            border-radius: 8px;
            border: 1px solid #DCBB89;
            width: 310px;

            .order-top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #F5F5F5;
                padding-bottom: 13px;

                .order-name {
                    font-size: 17px;
                    font-weight: 500;
                    color: #333;
                    margin-bottom: 5px;
                    font-family: 'PingFang SC-Medium';
                }

                .order-status {
                    font-size: 15px;
                    font-weight: 400;
                    color: #FF7123;
                    font-family: 'PingFang SC-Medium';
                }
            }

            .order-bottom {
                padding-top: 13px;

                .order-title {
                    font-size: 15px;
                    font-weight: 500;
                    color: #666;
                    font-family: 'PingFang SC-Medium';
                    margin-bottom: 8px;

                    .title-content {
                        font-size: 15px;
                        font-weight: 500;
                        color: #333;
                        font-family: 'PingFang SC-Medium';
                    }
                }

                .order-list-title {
                    margin-bottom: 8px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;

                    .title-content-list {
                        font-size: 15px;
                        font-weight: 500;
                        color: #666;
                        font-family: 'PingFang SC-Medium';
                    }

                    .content-list {
                        font-size: 15px;
                        font-weight: 500;
                        color: #333;
                        font-family: 'PingFang SC-Medium';
                    }
                }
            }
        }
    }
}

.border-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 17px 20px 17px;
    border-bottom: 1px solid #E5E5E5;
    background-color: #FFFFFF;

    .border-center {
        display: flex;
        align-items: center;

        .full-select {
            font-size: 15px;
            color: #333;
            font-family: 'PingFang SC-Medium';
            font-weight: 500;
            margin-left: 4px;
        }
    }

    .border-cancel {
        width: 105px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #eee;
        font-size: 15px;
        color: #666;
        font-family: 'PingFang SC-Medium';
        font-weight: 400;
        line-height: 36px;
        text-align: center;
        margin-left: 44px;
    }

    .border-go {
        font-size: 15px;
        color: #fff;
        width: 105px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #DCBB89;
        font-size: 15px;
        font-family: 'PingFang SC-Medium';
        font-weight: 400;
        line-height: 36px;
        text-align: center;
        background-color: #DCBB89;
    }
}
</style>